import { DEFAULT_INTEREST_MESSAGE, NSOKO_PHONE_NUMBER } from '../../constants'
import React from 'react'

import ReactWhatsapp from 'react-whatsapp'
import { ButtonProps } from '@chakra-ui/react'
import { FaWhatsapp } from 'react-icons/fa'
import { Property } from 'generated/graphql'

import { iconSizes } from 'theme'
import { useTranslation } from 'react-i18next'
import { PrimaryButton } from 'components/Buttons'

type WhatsappContactProps = {
  phoneNumber?: string
  propertyData: Property
} & ButtonProps

const WhatsappContact: React.FC<WhatsappContactProps> = ({ phoneNumber, ...rest }) => {
  const { t } = useTranslation()
  return (
    <ReactWhatsapp number={phoneNumber as string} element="div" message={DEFAULT_INTEREST_MESSAGE}>
      <PrimaryButton
        width="100%"
        rounded="md"
        fontSize="x-small"
        colorScheme="whatsapp"
        leftIcon={<FaWhatsapp size={iconSizes.md} />}
        {...rest}
      >
        {t('property_details.contact_on_whatsapp')}
      </PrimaryButton>
    </ReactWhatsapp>
  )
}

WhatsappContact.defaultProps = {
  phoneNumber: NSOKO_PHONE_NUMBER
}

export default WhatsappContact
